import request from '@/utils/request';

export function getMainWatchRisk() { 
  return request({
    url: `/api/watchrisk/main`,
    method: "get"
  })
}

export function createMainWatchRisk(data) { 
  return request({
    url: `/api/watchrisk/main`,
    method: "post",
    data: data
  })
}

export function getMainWatchRiskByUID(uid) { 
  return request({
    url: `/api/watchrisk/main/${uid}`,
    method: "get"
  })
}

export function putMainWatchRisk(uid, data) {
  return request({
    url: `/api/watchrisk/main/${uid}`,
    method: "put",
    data: data
  })
}
 
export function deleteMainWatchRisk(uid) { 
  return request({
    url: `/api/watchrisk/main/${uid}`,
    method: "delete"
  })
}

